import { render } from "./VatReverseCheckbox.vue?vue&type=template&id=d4677f40"
import script from "./VatReverseCheckbox.vue?vue&type=script&lang=js"
export * from "./VatReverseCheckbox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__